class CtxCarouselItemController {
    constructor($scope, $element) {
        this.$scope = $scope;
        this.$element = $element;
    }
    $onInit() {
        this.$scope.$watch(() => this.$element.hasClass('active'), active => {
            if ((typeof this.onShow === 'function') && active) this.onShow();
        });
    }
}

CtxCarouselItemController.$inject = ['$scope', '$element']

class ctxCarouselItemDirective {
    constructor($timeout) {
        this.$timeout = $timeout;
        this.scope = true;
        this.restrict = 'A';
        this.transclude = true;
        this.require = '^^ctxCarousel';
        this.controller = CtxCarouselItemController;
        this.controllerAs = 'ctxCarouselItemCtrl';
        this.bindToController = {
            onShow: '&?'
        }
    }

    link(scope, element, attrs, ctxCarousel, transclude) {
        ctxCarousel.addItem(this);
        let transcludedContent, transclusionScope;
        transclude((clone, scope) => {
            element.append(clone);
            transcludedContent = clone;
            transclusionScope = scope;
        });
        element.addClass('item');
        if (angular.isDefined(attrs.initState) && (angular.isUndefined(attrs.hasSecondInit) || attrs.hasSecondInit === "false")) {
            // default adding active class to init-state carousel-item
            element.addClass('active');
        }
        if (angular.isDefined(attrs.secondInit) && attrs.secondInit === 'true') {
            // adding active class to carousel-item that in some cases should be first and active
            element.addClass('active');
        }

        scope.$on("$destroy", () => {
            transcludedContent.remove();
            transclusionScope.$destroy();
        });
    }

    static directiveFactory($timeout) {
        return new ctxCarouselItemDirective($timeout);
    }
}

ctxCarouselItemDirective.directiveFactory.$inject = ['$timeout'];

module.exports = ctxCarouselItemDirective.directiveFactory;


// WEBPACK FOOTER //
// ./src/shared/ctxCarousel/ctxCarouselItem.directive.js